export default "__VITE_ASSET__0c1dd9bc__"